import http from '@/core/http';

const miniapp = {
  actions: {
    // 小程序列表
    MiniappList (ctx, payload) {
      return http.req_post('/admin/action/getwxapplist', { ...payload });
    },
    // 上传校验文件
    MiniappUploadFile (ctx, payload) {
      return http.req_post('/admin/action/uploadtxt', { ...payload });
    },
    // 修改小程序信息
    MiniappSetInfo (ctx, payload) {
      return http.req_post('/admin/action/setwxapp', { ...payload });
    },
    // 小程序体验者绑定
    MiniappBindTester (ctx, payload) {
      return http.req_post('/admin/action/wxappbindtester', { ...payload });
    },
    // 小程序体验者解绑
    MiniappUnbindTester (ctx, payload) {
      return http.req_post('/admin/action/wxappunbindtester', { ...payload });
    },
    // 小程序审核记录
    MiniappReviewRecord (ctx, payload) {
      return http.req_post('/admin/action/wxappauditlist', { ...payload });
    },
    // 小程序审核详情
    MiniappReviewInfo (ctx, payload) {
      return http.req_post('/admin/action/wxappaudit', { ...payload });
    },
    // 提交小程序反馈重新提审
    MiniappFeedbackResubmit (ctx, payload) {
      return http.req_post('/admin/action/publishwxapp', { ...payload });
    },
    // 获取小程序设置的信息
    MiniappGetConfigs (ctx, payload) {
      return http.req_post('/admin/action/wxappinfo', { ...payload });
    },
    // 设置小程序配置信息
    MiniappSetConfigs (ctx, payload) {
      return http.req_post('/admin/action/setwxappsetting', { ...payload });
    },
    // 小程序重新提审
    MiniappResubmit (ctx, payload) {
      return http.req_post('/admin/action/reaudit', { ...payload });
    },
  },
};

export default miniapp;